import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn($scope, $filter, $translate, claimViewModel, ViewModelService, ModalService) {
    var ctrl = Object.create(BaseCtrl);

    ctrl.init = function () {
        $scope.claimVm = ViewModelService.create(claimViewModel().value, 'cc', 'edge.capabilities.claim.fnol.dto.FnolDTO', {
            'InjuryDetailsValidation': true
        });
    };

    ctrl.addBodyPartDetails = function () {
        $scope.claimVm.lobs.workersComp.value.addBodyPartDetails();
    };

    ctrl.removeBodyPartDetails = function (bodyPart, index) {
        ModalService.showWarning('fnol.wc.views.injury.Remove Body Injury', $translate('fnol.wc.views.injury.Are you sure you want to remove Body Injury #{{bodyPartDetail}}?', {
            bodyPartDetail: index
        }), null, $filter('translate')('fnol.wc.views.injury.Remove')).result.then(function () {
            return $scope.claimVm.lobs.workersComp.value.removeBodyPartDetails(bodyPart.value);
        });
    };

    ctrl.next = function (nextFn) {
        nextFn($scope.claimVm);
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', '$filter', '$translate', 'claimViewModel', 'ViewModelService', 'ModalService'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/wc/controllers/WCInjuryCtrl.js
// module id = 1600
// module chunks = 0